module.exports = __webpack_public_path__ + "img/icon-archive.828fde08.png";